module.exports = __webpack_public_path__ + "img/creative_thumbnail-600x450.b87ad02f.jpg";